module.exports = __webpack_public_path__ + "static/img/otplatapozajmice2.ee6848c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kup/tutorial/otplatapozajmice2.png
// module id = rPHC
// module chunks = 0